<template>
<div>

<div id="item"></div>

	<div class="uk-container-expand firstScreen">
		<appNav></appNav>
		<div class="wrapUtp">
      
			<!-- <img class="picUtp" src="/img/slogan6.svg" alt="" /> -->
      
			<div class="utp"><img class="koloski" src="/img/kol_l.svg" alt="" /> <img class="bottomTitle" src="/img/title.svg" alt=""> <img class="koloski" src="/img/kol_r.svg" alt="" /></div>
			
		</div>
		
	</div>
	


	<div class="uk-container">
			<div id="two"></div>
		<div class="uk-text-center">
			<router-link to="/products">
			<a class="uk-h3 uk-text-center titleProducts uk-button uk-button-text"> 
				<i class="linkIcon mdi mdi-link-variant"></i>
				Продукция
				</a></router-link>
		</div>
		
		
	
		
		<div class="CardFirstProducts uk-child-width-1-5@l uk-child-width-1-4@m uk-child-width-1-3@s uk-child-width-1-2 uk-grid-small" uk-grid	>
    <div v-for="bread in getBreads.slice(0, 15)" :key="bread.id">
        <div  class="uk-card uk-card-hover uk-card-default">
					<router-link :to="'/product/' + bread.id" class="uk-link-reset">
            <div class="uk-card-media-top">

                <img :src="bread.picSrc" alt="">
            </div>
            <div class="uk-card-body uk-card-small">
                <p>{{ bread.name }}</p>
								<div class="uk-visible@s uk-label">{{ bread.sort }}</div>
            </div>
					</router-link>
        </div>
				</div>
		</div>


	</div>


<br>
<br>
<br>
<br>

				<div class="uk-section-default">

				<div class="uk-section uk-light uk-background-fixed uk-background-cover" style="background-image: url(/img/video_bg.jpg)">

				<div class="uk-container-expand">

					<div class="uk-text-center">
						<div class="uk-h3 uk-text-center titleVideo uk-margin-remove"> 
						<i class="linkIcon mdi mdi-library-video"></i>
						Полезное видео
						</div>
					</div>

					<div class=" uk-grid-small uk-text-center aboutVideo" uk-grid>
						<div class="uk-width-1-2@m uk-width-1-2@s uk-width-1-1"
						v-for="video in getVideos" :key="video.id"
						>
						<div uk-lightbox>
						<a class="uk-button uk-button-default" :href="video.vurl">{{ video.name }} <span>{{ video.spanName }}</span> <br> <img :src="video.picUrl" /></a>
						</div>
						
						</div>
						<hr>
						<a class="goFacebook" href="https://www.facebook.com/pg/gridnevhleb1/videos/?ref=page_internal" target="_blank">посмотреть на facebook</a>
					</div>

				</div>
				</div>
				</div>



<div class="uk-container">
					<div class="uk-text-center insta uk-grid-small uk-flex uk-flex-middle" uk-grid>
						<div class="uk-width-1-2@l uk-width-1-2@m uk-width-1-3@s uk-width-1-1">
								<div class="">
									<img class="imgInst" src="/img/inst.jpg" />
								</div>
						</div>
						<div class="uk-width-1-2@l uk-width-1-2@m uk-width-2-3@s uk-width-1-1">
								<a href="https://www.instagram.com/gridnevhleb/" target="_blank" class=" uk-link-reset">
								<div class="uk-card uk-card-default uk-card-body uk-card-hover subscrInst">
									<div class="uk-h3 ourInsta"><i class="mdi mdi-open-in-new"></i>Подпишись на наш инстаграм  </div>
									<ul class="uk-list">
										<li>РЕЦЕПТЫ | КОНКУРСЫ | ВСЯ ПРАВДА О ХЛЕБЕ</li>
									</ul>
								</div>
									
								</a>
						</div>
				</div>
</div>


				<br>
				<br>
				

				<div class="uk-container">
					<button  class="uk-margin uk-button uk-button-text " href="#item" uk-scroll> <i class="mdi mdi-chevron-up"></i>Наверх</button>
				</div>

				<br>
				<br>
		

	</div>
</template>


<script>
import appNav from '@/components/Nav'

export default {

	data () {
		return {
			ms: 'Честный хлеб от корки до корки',
			
		}
	},
	computed: {
		getBreads (){
			return this.$store.getters.getBreads
		},
		getVideos () {
			return this.$store.getters.getVideos
		}
	},
	components: {
		appNav
	}
}
</script>





<style>

.goFacebook {
	border:none !important;
	text-decoration: none !important;
	font-weight: 300 !important;
	padding-top: 20px !important;
	display: block !important;
	margin: 0 auto;
}




.linkIcon {
	color:#777;
}

.firstScreen .uk-navbar-container:not(.uk-navbar-transparent) {
	background-color: transparent;
	/* background: linear-gradient(0deg, rgba(0, 0, 0, 0.0001) 0%, #252424 150.79%); */
}


.firstScreen .uk-navbar-nav>li>a {
	color: #fff;
	font-weight: 700;
}

.firstScreen .uk-navbar-nav>li>a:hover{
	color:#ecf0f1;
	/* color:#c0392b; */
}

.firstScreen .leftMenu .uk-navbar-toggle{
color:#fff;
}

.firstScreen{
	background-image: url(/img/010_2.jpg);
	background-size: cover;
	width: 100%;
	min-height: 100vh;
}



.wrapUtp {
	/* min-height: 50vh; */
	min-height: calc(100vh - 229px);
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	align-items: center;
	/* background-color: #ccc; */
}

.utp{
	text-align: center;
	color:#fff ;
	font-weight: 400;
	font-size: 20px ;
	/* margin: 0 !important; */
	background: #e81a1c;
	padding: 5px 0px;
	/* border-radius: 8px 8px 0 0; */
	text-transform: uppercase;
  width: 100%;
}

.wrapUtp .picUtp {
	margin-top: 100px;
	width: 460px;
	/* margin-right: -350px; */
}

.wrapUtp .bottomTitle {
	margin: 0 30px;
}

.wrapUtp .koloski {
	width: 35px;
}


.goDown {
	background-color: #fff;
	border-radius: 50px;
	font-size: 25px;
	color:#B94547;
	text-decoration: none;
	transition: ease-in .3s;
	display: inline-block;
}

.goDown:hover {
	transform: translateY(5px);
}

.goDown:hover i{
	color:#D54F52;

}




.titleProducts {
	margin-top: 40px;
	color:#DE1F24;
	font-weight: 500;
	font-size: 20px;
	text-transform: uppercase;
}

.titleProducts:hover{
	color:#B94547;
}

.CardFirstProducts{
	margin-top: 50px;
	margin-bottom: 50px;
}

.CardFirstProducts p{
	height: 50px;
}






.titleVideo{
	margin-top: 40px;
	color:#DE1F24;
	font-weight: 500;
	font-size: 20px;
	text-transform: uppercase;
}

.titleVideo i{
	color:#fff;
}

.aboutVideo{
	margin: 50px 0;
}

.aboutVideo a{
	outline: none;
	border:1px solid #ccc;
	font-weight: 500;
}

.aboutVideo a span{
	font-weight: 300;
}


.insta{
	margin-top: 40px;
	margin-bottom: 20px;
}

.imgInst {
	width: 100%;
	max-width: 100%;
}

.ourInsta {
	color:#DC2125;
}

.ourInsta i {
	font-size: 18px;
	color:#777;
	margin-right: 15px;
}






@media only screen and (max-width: 952px) {
	.dash_logo {
		padding-top: 0;
	}
	.wrapUtp {
		min-height: 76vh;
	}
}


@media only screen and (max-width: 800px) {
	.wrapUtp {
		min-height: 78vh;
	}
}

@media only screen and (max-width: 768px) {
	.wrapUtp {
		min-height: 79vh;
	}
}


@media only screen and (max-width: 600px) {
	.wrapUtp {
		min-height: 91vh;
	}
}


@media only screen and (max-width: 576px) {
	.wrapUtp {
		min-height: 91vh;
	}
}

@media only screen and (max-width: 375px) {
	.wrapUtp .bottomTitle{
		margin: 0 9px;
	}
}

@media only screen and (max-width: 360px) {
	.wrapUtp .bottomTitle{
		margin:  0;
	}
}

@media only screen and (max-width: 320px) {
	.wrapUtp .bottomTitle{
		margin: 0;
		width: 70%;
	}
}

</style>